export const countries = [
  { alpha2: "AR", emoji: "🇦🇷", name: "Argentina" },
  { alpha2: "AT", emoji: "🇦🇹", name: "Austria" },
  { alpha2: "AU", emoji: "🇦🇺", name: "Australia" },
  { alpha2: "BH", emoji: "🇧🇭", name: "Bahrain" },
  { alpha2: "BE", emoji: "🇧🇪", name: "Belgium" },
  { alpha2: "BR", emoji: "🇧🇷", name: "Brazil" },
  { alpha2: "BG", emoji: "🇧🇬", name: "Bulgaria" },
  { alpha2: "CA", emoji: "🇨🇦", name: "Canada" },
  { alpha2: "CH", emoji: "🇨🇭", name: "Switzerland" },
  { alpha2: "CN", emoji: "🇨🇳", name: "China" },
  { alpha2: "CY", emoji: "🇨🇾", name: "Cyprus" },
  { alpha2: "CZ", emoji: "🇨🇿", name: "Czech Republic" },
  { alpha2: "DE", emoji: "🇩🇪", name: "Germany" },
  { alpha2: "DK", emoji: "🇩🇰", name: "Denmark" },
  { alpha2: "EE", emoji: "🇪🇪", name: "Estonia" },
  { alpha2: "EG", emoji: "🇪🇬", name: "Egypt" },
  { alpha2: "ES", emoji: "🇪🇸", name: "Spain" },
  { alpha2: "FI", emoji: "🇫🇮", name: "Finland" },
  { alpha2: "FR", emoji: "🇫🇷", name: "France" },
  { alpha2: "GB", emoji: "🇬🇧", name: "United Kingdom" },
  { alpha2: "GR", emoji: "🇬🇷", name: "Greece" },
  { alpha2: "HR", emoji: "🇭🇷", name: "Croatia" },
  { alpha2: "HU", emoji: "🇭🇺", name: "Hungary" },
  { alpha2: "IE", emoji: "🇮🇪", name: "Ireland" },
  { alpha2: "IN", emoji: "🇮🇳", name: "India" },
  { alpha2: "IQ", emoji: "🇮🇶", name: "Iraq" },
  { alpha2: "IS", emoji: "🇮🇸", name: "Iceland" },
  { alpha2: "IT", emoji: "🇮🇹", name: "Italy" },
  { alpha2: "JP", emoji: "🇯🇵", name: "Japan" },
  { alpha2: "KW", emoji: "🇰🇼", name: "Kuwait" },
  { alpha2: "LB", emoji: "🇱🇧", name: "Lebanon" },
  { alpha2: "LT", emoji: "🇱🇹", name: "Lithuania" },
  { alpha2: "LU", emoji: "🇱🇺", name: "Luxembourg" },
  { alpha2: "LV", emoji: "🇱🇻", name: "Latvia" },
  { alpha2: "MC", emoji: "🇲🇨", name: "Monaco" },
  { alpha2: "MT", emoji: "🇲🇹", name: "Malta" },
  { alpha2: "MX", emoji: "🇲🇽", name: "Mexico" },
  { alpha2: "MY", emoji: "🇲🇾", name: "Malaysia" },
  { alpha2: "NL", emoji: "🇳🇱", name: "Netherlands" },
  { alpha2: "NO", emoji: "🇳🇴", name: "Norway" },
  { alpha2: "NZ", emoji: "🇳🇿", name: "New Zealand" },
  { alpha2: "OM", emoji: "🇴🇲", name: "Oman" },
  { alpha2: "PL", emoji: "🇵🇱", name: "Poland" },
  { alpha2: "PT", emoji: "🇵🇹", name: "Portugal" },
  { alpha2: "QA", emoji: "🇶🇦", name: "Qatar" },
  { alpha2: "RO", emoji: "🇷🇴", name: "Romania" },
  { alpha2: "RU", emoji: "🇷🇺", name: "Russia" },
  { alpha2: "SA", emoji: "🇸🇦", name: "Saudi Arabia" },
  { alpha2: "SE", emoji: "🇸🇪", name: "Sweden" },
  { alpha2: "SG", emoji: "🇸🇬", name: "Singapore" },
  { alpha2: "SI", emoji: "🇸🇮", name: "Slovenia" },
  { alpha2: "SK", emoji: "🇸🇰", name: "Slovakia" },
  { alpha2: "SM", emoji: "🇸🇲", name: "San Marino" },
  { alpha2: "TH", emoji: "🇹🇭", name: "Thailand" },
  {
    alpha2: "AE",
    emoji: "🇦🇪",
    name: "United Arab Emirates",
  },
  { alpha2: "US", emoji: "🇺🇸", name: "United States" },
  { alpha2: "VA", emoji: "🇻🇦", name: "Vatican City" },
  { alpha2: "ZA", emoji: "🇿🇦", name: "South Africa" },
];

export const cities = [
  { value: "Aadchit", label: "Aadchit" },
  { value: "Aarab Salim", label: "Aarab Salim" },
  { value: "Aaramta", label: "Aaramta" },
  { value: "Aazour", label: "Aazour" },
  { value: "Ablah", label: "Ablah" },
  { value: "Abra", label: "Abra" },
  { value: "Abu Mizan", label: "Abu Mizan" },
  { value: "Ad Dalhamiyah", label: "Ad Dalhamiyah" },
  { value: "Ad Dashuniyah", label: "Ad Dashuniyah" },
  { value: "Ad Dikwanah", label: "Ad Dikwanah" },
  { value: "Ad Dulb", label: "Ad Dulb" },
  { value: "Ad Duwayr", label: "Ad Duwayr" },
  { value: "Adlun", label: "Adlun" },
  { value: "Adma", label: "Adma" },
  { value: "Adunis", label: "Adunis" },
  { value: "Afqa", label: "Afqa" },
  { value: "Aghmid", label: "Aghmid" },
  { value: "Ain Qana", label: "Ain Qana" },
  { value: "Ain Tanta", label: "Ain Tanta" },
  { value: "Ajaltun", label: "Ajaltun" },
  { value: "Akkar Al Atiqah", label: "Akkar Al Atiqah" },
  { value: "Al Amarah", label: "Al Amarah" },
  { value: "Al Arz", label: "Al Arz" },
  { value: "Al Ashrafiyah", label: "Al Ashrafiyah" },
  { value: "Al Azr", label: "Al Azr" },
  { value: "Al Babliyah", label: "Al Babliyah" },
  { value: "Al Baddawi", label: "Al Baddawi" },
  { value: "Al Bahsas", label: "Al Bahsas" },
  { value: "Al Bahsasah", label: "Al Bahsasah" },
  { value: "Al Barid", label: "Al Barid" },
  { value: "Al Basatin", label: "Al Basatin" },
  { value: "Al Bashurah", label: "Al Bashurah" },
  { value: "Al Bazuriyah", label: "Al Bazuriyah" },
  { value: "Al Burj", label: "Al Burj" },
  { value: "Al Burjayn", label: "Al Burjayn" },
  { value: "Al Bwar", label: "Al Bwar" },
  { value: "Al Fawwar", label: "Al Fawwar" },
  { value: "Al Fidar", label: "Al Fidar" },
  { value: "Al Ghanduriyah", label: "Al Ghanduriyah" },
  { value: "Al Ghaziyah", label: "Al Ghaziyah" },
  { value: "Al Hadath", label: "Al Hadath" },
  { value: "Al Hamra", label: "Al Hamra" },
  { value: "Al Hazimiyah", label: "Al Hazimiyah" },
  { value: "Al Hirmil", label: "Al Hirmil" },
  { value: "Al Jahiliyah", label: "Al Jahiliyah" },
  { value: "Al Jiyah", label: "Al Jiyah" },
  { value: "Al Judaydah", label: "Al Judaydah" },
  { value: "Al Kaslik", label: "Al Kaslik" },
  { value: "Al Khallah", label: "Al Khallah" },
  { value: "Al Khinsharah", label: "Al Khinsharah" },
  { value: "Al Knaysah", label: "Al Knaysah" },
  { value: "Al Ksarah", label: "Al Ksarah" },
  { value: "Al Kufur", label: "Al Kufur" },
  { value: "Al Labwah", label: "Al Labwah" },
  { value: "Al Laqluq", label: "Al Laqluq" },
  { value: "Al Laylakah", label: "Al Laylakah" },
  { value: "Al Luwayzah", label: "Al Luwayzah" },
  { value: "Al Maamiltayn", label: "Al Maamiltayn" },
  { value: "Al Madfun", label: "Al Madfun" },
  { value: "Al Majadil", label: "Al Majadil" },
  { value: "Al Majdal", label: "Al Majdal" },
  { value: "Al Majidiyah", label: "Al Majidiyah" },
  { value: "Al Mansuri", label: "Al Mansuri" },
  { value: "Al Mansuriyah", label: "Al Mansuriyah" },
  { value: "Al Marwaniyah", label: "Al Marwaniyah" },
  { value: "Al Mashraf", label: "Al Mashraf" },
  { value: "Al Mashrafah", label: "Al Mashrafah" },
  { value: "Al Mina", label: "Al Mina" },
  { value: "Al Minyah", label: "Al Minyah" },
  { value: "Al Miyasah", label: "Al Miyasah" },
  { value: "Al Mudawwar", label: "Al Mudawwar" },
  { value: "Al Mudayrij", label: "Al Mudayrij" },
  { value: "Al Mukhtarah", label: "Al Mukhtarah" },
  { value: "Al Munsif", label: "Al Munsif" },
  { value: "Al Murayjah", label: "Al Murayjah" },
  { value: "Al Murayjat", label: "Al Murayjat" },
  { value: "Al Muruj", label: "Al Muruj" },
  { value: "Al Musaytbah", label: "Al Musaytbah" },
  { value: "Al Musaytibah", label: "Al Musaytibah" },
  { value: "Al Mutaylib", label: "Al Mutaylib" },
  { value: "Al Mutayn", label: "Al Mutayn" },
  { value: "Al Muzayriah", label: "Al Muzayriah" },
  { value: "Al Qalamun", label: "Al Qalamun" },
  { value: "Al Qalilah", label: "Al Qalilah" },
  { value: "Al Qanabah", label: "Al Qanabah" },
  { value: "Al Qantarah", label: "Al Qantarah" },
  { value: "Al Qantari", label: "Al Qantari" },
  { value: "Al Qasimiyah", label: "Al Qasimiyah" },
  { value: "Al Qattin", label: "Al Qattin" },
  { value: "Al Qbayyat", label: "Al Qbayyat" },
  { value: "Al Qunaytirah", label: "Al Qunaytirah" },
  { value: "Al Wardaniyah", label: "Al Wardaniyah" },
  { value: "Al Warhaniyah", label: "Al Warhaniyah" },
  { value: "Al Wazzani", label: "Al Wazzani" },
  { value: "Al Yammunah", label: "Al Yammunah" },
  { value: "Aley", label: "Aley" },
  { value: "Ali An Nahri", label: "Ali An Nahri" },
  { value: "Alma", label: "Alma" },
  { value: "Alma Ash Shab", label: "Alma Ash Shab" },
  { value: "Alman", label: "Alman" },
  { value: "Almat", label: "Almat" },
  { value: "Amioun", label: "Amioun" },
  { value: "Ammiq", label: "Ammiq" },
  { value: "Amshit", label: "Amshit" },
  { value: "An Nabah", label: "An Nabah" },
  { value: "An Nabi Shit", label: "An Nabi Shit" },
  { value: "An Nabi Uthman", label: "An Nabi Uthman" },
  { value: "An Naqqash", label: "An Naqqash" },
  { value: "Anjar", label: "Anjar" },
  { value: "Ansar", label: "Ansar" },
  { value: "Antilyas", label: "Antilyas" },
  { value: "Ar Rabiyah", label: "Ar Rabiyah" },
  { value: "Ar Rawshah", label: "Ar Rawshah" },
  { value: "Ar Ruays", label: "Ar Ruays" },
  { value: "Ar Rumayl", label: "Ar Rumayl" },
  { value: "Ar Rumaylah", label: "Ar Rumaylah" },
  { value: "Aramun", label: "Aramun" },
  { value: "Arayya", label: "Arayya" },
  { value: "Arnoun", label: "Arnoun" },
  { value: "As Safra", label: "As Safra" },
  { value: "As Safrah", label: "As Safrah" },
  { value: "As Samqaniyah", label: "As Samqaniyah" },
  { value: "As Sayfi", label: "As Sayfi" },
  { value: "As Sultan Yaqub", label: "As Sultan Yaqub" },
  {
    value: "as Sultan Yaqub At Tahta",
    label: "as Sultan Yaqub At Tahta",
  },
  { value: "Ash Shaqif", label: "Ash Shaqif" },
  { value: "Ashqut", label: "Ashqut" },
  { value: "At Tayyibah", label: "At Tayyibah" },
  { value: "At Tiri", label: "At Tiri" },
  { value: "Awkar", label: "Awkar" },
  { value: "Ayn Ar", label: "Ayn Ar" },
  { value: "Ayn Ata", label: "Ayn Ata" },
  { value: "Ayn Darah", label: "Ayn Darah" },
  { value: "Ayn Hammana", label: "Ayn Hammana" },
  { value: "Ayn Ibil", label: "Ayn Ibil" },
  { value: "Ayn Najm", label: "Ayn Najm" },
  { value: "Ayn Saadah", label: "Ayn Saadah" },
  { value: "Ayn Wzayn", label: "Ayn Wzayn" },
  { value: "Ayn Zaytun", label: "Ayn Zaytun" },
  { value: "Ayn Zubdah", label: "Ayn Zubdah" },
  { value: "Aynata", label: "Aynata" },
  { value: "Aynturah", label: "Aynturah" },
  { value: "Aytit", label: "Aytit" },
  { value: "Az Zaytuniyah", label: "Az Zaytuniyah" },
  { value: "Az Zuaytirah", label: "Az Zuaytirah" },
  { value: "Az Zuaytiriyah", label: "Az Zuaytiriyah" },
  { value: "Baabda", label: "Baabda" },
  { value: "Baalbeck", label: "Baalbeck" },
  { value: "Babdat", label: "Babdat" },
  { value: "Bakkifa", label: "Bakkifa" },
  { value: "Balabakk", label: "Balabakk" },
  { value: "Baqlin", label: "Baqlin" },
  { value: "Barja", label: "Barja" },
  { value: "Barr Ilyas", label: "Barr Ilyas" },
  { value: "Batroun", label: "Batroun" },
  { value: "Baysur", label: "Baysur" },
  { value: "Bayt Al Kuku", label: "Bayt Al Kuku" },
  { value: "Bayt Ash Shaar", label: "Bayt Ash Shaar" },
  { value: "Bayt Lif", label: "Bayt Lif" },
  { value: "Bayt Miri", label: "Bayt Miri" },
  { value: "Bcharre", label: "Bcharre" },
  { value: "Bdadun", label: "Bdadun" },
  { value: "Beirut", label: "Beirut" },
  { value: "Beit Ed Dine", label: "Beit Ed Dine" },
  { value: "Bent Jbail", label: "Bent Jbail" },
  { value: "Berbara", label: "Berbara" },
  { value: "Bhamdun", label: "Bhamdun" },
  {
    value: "Bhamdun Al Mahattah",
    label: "Bhamdun Al Mahattah",
  },
  { value: "Bibnin", label: "Bibnin" },
  { value: "Bidnayil", label: "Bidnayil" },
  { value: "Bikfaiya", label: "Bikfaiya" },
  { value: "Bir Hasan", label: "Bir Hasan" },
  { value: "Blat", label: "Blat" },
  { value: "Bnashi", label: "Bnashi" },
  { value: "Brital", label: "Brital" },
  { value: "Brummana", label: "Brummana" },
  { value: "Bsaba", label: "Bsaba" },
  { value: "Bsalim", label: "Bsalim" },
  { value: "Bshamun", label: "Bshamun" },
  { value: "Bsus", label: "Bsus" },
  { value: "Btighrin", label: "Btighrin" },
  { value: "Bu Zuraydah", label: "Bu Zuraydah" },
  { value: "Buqata", label: "Buqata" },
  {
    value: "Burj Al Barajinah",
    label: "Burj Al Barajinah",
  },
  { value: "Burj Hammud", label: "Burj Hammud" },
  { value: "Burj Rahhal", label: "Burj Rahhal" },
  { value: "Byaqut", label: "Byaqut" },
  { value: "Bziza", label: "Bziza" },
  { value: "Bzummar", label: "Bzummar" },
  { value: "Chaqra", label: "Chaqra" },
  { value: "Chartoun", label: "Chartoun" },
  { value: "Chekka", label: "Chekka" },
  { value: "Choukine", label: "Choukine" },
  { value: "Chtaura", label: "Chtaura" },
  { value: "Dahr Al Bashiq", label: "Dahr Al Bashiq" },
  { value: "Dahr Al Magharah", label: "Dahr Al Magharah" },
  { value: "Dahr As Sawwan", label: "Dahr As Sawwan" },
  { value: "Dahr El Ahmar", label: "Dahr El Ahmar" },
  { value: "Dalhun", label: "Dalhun" },
  { value: "Damour", label: "Damour" },
  { value: "Darayya", label: "Darayya" },
  { value: "Dawra", label: "Dawra" },
  { value: "Dayr Al Ahmar", label: "Dayr Al Ahmar" },
  { value: "Dayr Al Harf", label: "Dayr Al Harf" },
  { value: "Dayr Al Qamar", label: "Dayr Al Qamar" },
  { value: "Dayr Ammar", label: "Dayr Ammar" },
  { value: "Dayr Mimas", label: "Dayr Mimas" },
  { value: "Dayr Qubil", label: "Dayr Qubil" },
  { value: "Dbayeh", label: "Dbayeh" },
  {
    value: "Deir El Moukhalles",
    label: "Deir El Moukhalles",
  },
  { value: "Dfun", label: "Dfun" },
  { value: "Dibal", label: "Dibal" },
  { value: "Dibbine", label: "Dibbine" },
  { value: "Dibil", label: "Dibil" },
  { value: "Diddah", label: "Diddah" },
  { value: "Dik Al Mihdi", label: "Dik Al Mihdi" },
  {
    value: "Dmit Al Jawwaniyah",
    label: "Dmit Al Jawwaniyah",
  },
  { value: "Douma", label: "Douma" },
  { value: "Ebel Es Saqi", label: "Ebel Es Saqi" },
  { value: "Ed Douair", label: "Ed Douair" },
  { value: "El Aaqaide", label: "El Aaqaide" },
  { value: "El Arz", label: "El Arz" },
  { value: "El Fourzol", label: "El Fourzol" },
  { value: "El Kfour", label: "El Kfour" },
  { value: "El Mansoura", label: "El Mansoura" },
  { value: "El Mina", label: "El Mina" },
  { value: "El Mrouj", label: "El Mrouj" },
  { value: "Falugha", label: "Falugha" },
  { value: "Fanar", label: "Fanar" },
  { value: "Farayya", label: "Farayya" },
  { value: "Fatqa", label: "Fatqa" },
  { value: "Fatri", label: "Fatri" },
  { value: "Faytrun", label: "Faytrun" },
  { value: "Fayyadiyah", label: "Fayyadiyah" },
  { value: "Frat", label: "Frat" },
  { value: "Furn Ash Shubbak", label: "Furn Ash Shubbak" },
  { value: "Ghabat Bulunya", label: "Ghabat Bulunya" },
  { value: "Ghadir", label: "Ghadir" },
  { value: "Gharifah", label: "Gharifah" },
  { value: "Ghassaniyah", label: "Ghassaniyah" },
  { value: "Ghazir", label: "Ghazir" },
  { value: "Ghidras", label: "Ghidras" },
  { value: "Ghusta", label: "Ghusta" },
  { value: "Habbouch", label: "Habbouch" },
  { value: "Hadath Al Jubbah", label: "Hadath Al Jubbah" },
  { value: "Hadshit", label: "Hadshit" },
  { value: "Haitoura", label: "Haitoura" },
  { value: "Halat", label: "Halat" },
  { value: "Halba", label: "Halba" },
  { value: "Hamat", label: "Hamat" },
  { value: "Hammana", label: "Hammana" },
  { value: "Hanin", label: "Hanin" },
  { value: "Haouch El Omara", label: "Haouch El Omara" },
  { value: "Harajil", label: "Harajil" },
  {
    value: "Harat Al Ballanah",
    label: "Harat Al Ballanah",
  },
  { value: "Harat Hurayk", label: "Harat Hurayk" },
  { value: "Harat Jandal", label: "Harat Jandal" },
  { value: "Harbata", label: "Harbata" },
  { value: "Hariis", label: "Hariis" },
  { value: "Harisa", label: "Harisa" },
  { value: "Harouf", label: "Harouf" },
  { value: "Hasbaiya", label: "Hasbaiya" },
  { value: "Hasbayya", label: "Hasbayya" },
  { value: "Hasrun", label: "Hasrun" },
  { value: "Hayy Mar Rukuz", label: "Hayy Mar Rukuz" },
  { value: "Hayyatah", label: "Hayyatah" },
  { value: "Hermel", label: "Hermel" },
  { value: "Himlaya", label: "Himlaya" },
  { value: "Ihmij", label: "Ihmij" },
  { value: "Irkay", label: "Irkay" },
  { value: "Irsal", label: "Irsal" },
  { value: "Jadra", label: "Jadra" },
  { value: "Jbail", label: "Jbail" },
  { value: "Jdita", label: "Jdita" },
  { value: "Jezzine", label: "Jezzine" },
  { value: "Jibal Al Butm", label: "Jibal Al Butm" },
  { value: "Jibchit", label: "Jibchit" },
  { value: "Jisr Al Basha", label: "Jisr Al Basha" },
  {
    value: "Jisr Nahr Ibrahim",
    label: "Jisr Nahr Ibrahim",
  },
  { value: "Jita", label: "Jita" },
  { value: "Joub Jannine", label: "Joub Jannine" },
  { value: "Jounie", label: "Jounie" },
  { value: "Judaydah", label: "Judaydah" },
  { value: "Judaydat Ghazir", label: "Judaydat Ghazir" },
  { value: "Jumhur", label: "Jumhur" },
  { value: "Jurat At Turmus", label: "Jurat At Turmus" },
  { value: "Kafr Hatta", label: "Kafr Hatta" },
  { value: "Kafr Hazir", label: "Kafr Hazir" },
  { value: "Kafr Hbab", label: "Kafr Hbab" },
  { value: "Kafr Kila", label: "Kafr Kila" },
  { value: "Kafr Matta", label: "Kafr Matta" },
  { value: "Kafr Milki", label: "Kafr Milki" },
  { value: "Kafr Nabrakh", label: "Kafr Nabrakh" },
  { value: "Kafr Shikht", label: "Kafr Shikht" },
  { value: "Kafr Silwan", label: "Kafr Silwan" },
  { value: "Kafr Sir", label: "Kafr Sir" },
  { value: "Kafra", label: "Kafra" },
  { value: "Kafrayya", label: "Kafrayya" },
  { value: "Kaoukaba", label: "Kaoukaba" },
  {
    value: "Kaoutariet Es Siyad",
    label: "Kaoutariet Es Siyad",
  },
  { value: "Kayfun", label: "Kayfun" },
  { value: "Kfar Fila", label: "Kfar Fila" },
  { value: "Kfar Hamam", label: "Kfar Hamam" },
  { value: "Kfar Houne", label: "Kfar Houne" },
  { value: "Kfar Jaouz", label: "Kfar Jaouz" },
  { value: "Kfar Roummane", label: "Kfar Roummane" },
  { value: "Kfar Tibnit", label: "Kfar Tibnit" },
  { value: "Khaldah", label: "Khaldah" },
  { value: "Khirbet Selm", label: "Khirbet Selm" },
  { value: "Kifrayya", label: "Kifrayya" },
  { value: "Kubba", label: "Kubba" },
  { value: "Kusba", label: "Kusba" },
  { value: "Lasa", label: "Lasa" },
  { value: "Machmouche", label: "Machmouche" },
  { value: "Maghdushah", label: "Maghdushah" },
  { value: "Maifadoun", label: "Maifadoun" },
  { value: "Majdal Anjar", label: "Majdal Anjar" },
  { value: "Majdal Bana", label: "Majdal Bana" },
  { value: "Majdalayya", label: "Majdalayya" },
  { value: "Majdalun", label: "Majdalun" },
  { value: "Majdalyun", label: "Majdalyun" },
  { value: "Majdel Selm", label: "Majdel Selm" },
  { value: "Mar Dumit", label: "Mar Dumit" },
  { value: "Mar Elias", label: "Mar Elias" },
  { value: "Mar Ilyas", label: "Mar Ilyas" },
  { value: "Mar Mikhail", label: "Mar Mikhail" },
  { value: "Mar Nahra", label: "Mar Nahra" },
  { value: "Mar Yusuf", label: "Mar Yusuf" },
  { value: "Marjayoun", label: "Marjayoun" },
  { value: "Marun Ar Ras", label: "Marun Ar Ras" },
  { value: "Marwahin", label: "Marwahin" },
  { value: "Mashgharah", label: "Mashgharah" },
  { value: "Masna Bidnayil", label: "Masna Bidnayil" },
  { value: "Mayruba", label: "Mayruba" },
  { value: "Mazar", label: "Mazar" },
  { value: "Mazraat Ad Duhur", label: "Mazraat Ad Duhur" },
  { value: "Mazraat As Siyad", label: "Mazraat As Siyad" },
  { value: "Mazraat Ash Shuf", label: "Mazraat Ash Shuf" },
  {
    value: "Mazraat Kafr Dhibyan",
    label: "Mazraat Kafr Dhibyan",
  },
  { value: "Mazraat Yashu", label: "Mazraat Yashu" },
  { value: "Miyasse", label: "Miyasse" },
  { value: "Mizyarah", label: "Mizyarah" },
  { value: "Mristi", label: "Mristi" },
  { value: "Nabay", label: "Nabay" },
  { value: "Nahr Al Mawt", label: "Nahr Al Mawt" },
  { value: "Nahr Ibrahim", label: "Nahr Ibrahim" },
  { value: "Naqoura", label: "Naqoura" },
  { value: "Qabr Chmoun", label: "Qabr Chmoun" },
  { value: "Qalhat", label: "Qalhat" },
  { value: "Qana", label: "Qana" },
  {
    value: "Qannabat Brummana",
    label: "Qannabat Brummana",
  },
  { value: "Qaraaoun", label: "Qaraaoun" },
  { value: "Qartaba", label: "Qartaba" },
  { value: "Qattin", label: "Qattin" },
  { value: "Qnabah", label: "Qnabah" },
  { value: "Qnat", label: "Qnat" },
  { value: "Qurnat Al Hamra", label: "Qurnat Al Hamra" },
  { value: "Qurnayil", label: "Qurnayil" },
  { value: "Rachaiya", label: "Rachaiya" },
  {
    value: "Rachaiya El Foukhar",
    label: "Rachaiya El Foukhar",
  },
  { value: "Ramlat Al Bayda", label: "Ramlat Al Bayda" },
  { value: "Ras Al Ayn", label: "Ras Al Ayn" },
  { value: "Ras Al Matn", label: "Ras Al Matn" },
  { value: "Ras An Naban", label: "Ras An Naban" },
  { value: "Ras Balabakk", label: "Ras Balabakk" },
  { value: "Ras Bayrut", label: "Ras Bayrut" },
  { value: "Ras Qusta", label: "Ras Qusta" },
  { value: "Rashin", label: "Rashin" },
  { value: "Rayak", label: "Rayak" },
  { value: "Rayfun", label: "Rayfun" },
  { value: "Rmaich", label: "Rmaich" },
  { value: "Rshaf", label: "Rshaf" },
  { value: "Sabtiyah", label: "Sabtiyah" },
  { value: "Saidoun", label: "Saidoun" },
  { value: "Sarba", label: "Sarba" },
  { value: "Sawfar", label: "Sawfar" },
  { value: "Sbuba", label: "Sbuba" },
  { value: "Semqaye", label: "Semqaye" },
  { value: "Shahtul", label: "Shahtul" },
  { value: "Shhim", label: "Shhim" },
  { value: "Siblin", label: "Siblin" },
  { value: "Tabarja", label: "Tabarja" },
  { value: "Tair Zebna", label: "Tair Zebna" },
  { value: "Talabaya", label: "Talabaya" },
  { value: "Tall Az Zatar", label: "Tall Az Zatar" },
  { value: "Talya", label: "Talya" },
  { value: "Tanayil", label: "Tanayil" },
  { value: "Tarayya", label: "Tarayya" },
  { value: "Temnine Et Tehta", label: "Temnine Et Tehta" },
  { value: "Tibnine", label: "Tibnine" },
  { value: "Trablous", label: "Trablous" },
  { value: "Turbul", label: "Turbul" },
  { value: "Tyre", label: "Tyre" },
  {
    value: "Wadi Shuhrur As Sufl",
    label: "Wadi Shuhrur As Sufl",
  },
  { value: "Wata Al Jawz", label: "Wata Al Jawz" },
  { value: "Yarin", label: "Yarin" },
  { value: "Yarun", label: "Yarun" },
  { value: "Yatar", label: "Yatar" },
  { value: "Yuhmur", label: "Yuhmur" },
  { value: "Zahiriyah", label: "Zahiriyah" },
  { value: "Zahle", label: "Zahle" },
  {
    value: "Zawtar Al Gharbiyah",
    label: "Zawtar Al Gharbiyah",
  },
  {
    value: "Zawtar Ash Sharqiyah",
    label: "Zawtar Ash Sharqiyah",
  },
  { value: "Zgharta", label: "Zgharta" },
  { value: "Zhilta", label: "Zhilta" },
  { value: "Zifta", label: "Zifta" },
  { value: "Zuq Al Kharab", label: "Zuq Al Kharab" },
  { value: "Zuq Musbih", label: "Zuq Musbih" },
];
